import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import AboutPage from '@/pages/about/page';
import ServicesPage from '@/pages/services/page';
import ContactPage from '@/pages/contact/page';
import ResidentialSettlementsPage from '@/pages/services/residential-settlements/page';
import TitleInsurancePage from '@/pages/services/title-insurance/page';
import TitleSearchesPage from '@/pages/services/title-searches/page';
import CommercialClosingsPage from '@/pages/services/commercial-closings/page';
import ExchangesPage from '@/pages/services/1031-exchanges/page';
import RefinancingPage from '@/pages/services/refinancing/page';
import DeedPreparationPage from '@/pages/services/deed-preparation/page';
import LienSearchesPage from '@/pages/services/lien-searches/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/services/residential-settlements',
    element: <ResidentialSettlementsPage />,
  },
  {
    path: '/services/title-insurance',
    element: <TitleInsurancePage />,
  },
  {
    path: '/services/title-searches',
    element: <TitleSearchesPage />,
  },
  {
    path: '/services/commercial-closings',
    element: <CommercialClosingsPage />,
  },
  {
    path: '/services/1031-exchanges',
    element: <ExchangesPage />,
  },
  {
    path: '/services/refinancing',
    element: <RefinancingPage />,
  },
  {
    path: '/services/deed-preparation',
    element: <DeedPreparationPage />,
  },
  {
    path: '/services/lien-searches',
    element: <LienSearchesPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
